import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ICalendarState, RawActions, IEventFilter } from '@adage/ace-calendar';
import axios from 'axios';

import DaysOfTheWeekView from '../views/days-of-the-week';
import { IWACEvent, InputOption, ICalendarReduxState } from '../classes';
import { selectFilterOption } from "../redux/actions/index";

interface DaysOfTheWeekExternalProps {
}

interface StateToProps {
    currentMoment: moment.Moment;
    startMoment: moment.Moment;
}

type DaysOfTheWeekProps = StateToProps & DaysOfTheWeekExternalProps;

interface DaysOfTheWeekState {
}

class DaysOfTheWeek extends React.Component<DaysOfTheWeekProps, DaysOfTheWeekState> {

    render(): JSX.Element {
        const colorClass = this.props.currentMoment.clone().startOf("month").startOf("month").diff(this.props.startMoment.clone(), "months") % 4;

        return <DaysOfTheWeekView colorClass={`month-${colorClass}-js`} />
    }
}

function mapStateToProps(state: ICalendarReduxState, externalProps: DaysOfTheWeekExternalProps) {
    return {
        currentMoment: state.calendarModel.currentDate,
        startMoment: state.calendarModel.startDate
    }
}


export default connect<StateToProps>(mapStateToProps)(DaysOfTheWeek);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/days-of-the-week.tsx